const Access_key = 'a504f13663b71de052e873dcc734221b'; 
const img_200 = "https://image.tmdb.org/t/p/w220_and_h330_face";
const img_og = "https://image.tmdb.org/t/p/original";
const unavailable = "https://www.movienewz.com/img/films/poster-holder.jpg";

export { Access_key, img_200, img_og, unavailable };